<div [attr.flexLayout]="props.flexLayout ?? 'row wrap'" [attr.flexLayoutAlign]="props.flexLayoutAlign" flexLayoutGap="16px grid">
  <ng-container #fieldComponent></ng-container>
</div>
